export interface Schema {
    '@context': string;
    '@type': string;
    name: string;
    description: string;
    aggregateRating: AggregateRating;
}

export interface AggregateRating {
    '@type': string;
    ratingValue: number;
    reviewCount: number;
}

export enum Types {
    AggregateRating = 'AggregateRating',
    Product = 'Product',
}
